import { type IApiConfig, NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { trackEvent } from "../tracking/trackEvent";
import { travelerApi as defaultTravelerApi } from "@b2bportal/traveler-api";
import axios from "axios";
import {
  CreateOrUpdateTravelerRequest,
  CreateOrUpdateTravelerResponse,
} from "@b2bportal/traveler-api/lib/api";

export const updateTraveler = (
  body: CreateOrUpdateTravelerRequest,
  apiConfig?: IApiConfig
): Promise<CreateOrUpdateTravelerResponse> =>
  new Promise((resolve, reject) => {
    const travelerApi = defaultTravelerApi(axios);
    travelerApi
      .apiV0TravelerPut(body)
      .then((response) => {
        const responseBody = response.data as CreateOrUpdateTravelerResponse;
        resolve(responseBody);
      })
      .catch((e) => {
        trackEvent(
          {
            eventName: NETWORK_CALL_FAILED,
            properties: {
              url: window.location.pathname,
            },
          },
          apiConfig
        );
        reject(e);
      });
  });
